module.exports = __webpack_public_path__ + "static/assets/0924f98476cfacbf8557c468e42d907a.svg";